import { render, staticRenderFns } from "./ElemUpload.vue?vue&type=template&id=3cb2def8&"
import script from "./ElemUpload.vue?vue&type=script&lang=js&"
export * from "./ElemUpload.vue?vue&type=script&lang=js&"
import style0 from "./ElemUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports